import { EnqueueFailureStatus, Prisma, prisma } from "client";

type RecordFailedEnqueueParams = {
  jobType: string;
  payload: unknown;
  whiteLabelId: string;
  errorMessage: string;
};

export async function recordFailedEnqueue({
  jobType,
  payload,
  whiteLabelId,
  errorMessage,
}: RecordFailedEnqueueParams): Promise<void> {
  try {
    await prisma.enqueueFailure.create({
      data: {
        jobType,
        payload: payload as Prisma.InputJsonValue,
        whiteLabelId,
        errorMessage,
        status: EnqueueFailureStatus.UNRESOLVED,
      },
    });
  } catch (error) {
    console.error("[EnqueueFailure] Could not persist enqueue failure", error);
  }
}
